const onPrimaryPalette = {
  'on-aqua': {
    50: { value: '#e6f7fc' },
    100: { value: '#b0e7f6' },
    200: { value: '#8adcf2' },
    300: { value: '#54cbec' },
    400: { value: '#33c1e8' },
    500: { value: '#00b2e2' }, //on-aqua
    600: { value: '#00a2ce' },
    700: { value: '#007ea0' },
    800: { value: '#00627c' },
    900: { value: '#004b5f' },
  },
  'brand-blue': {
    50: { value: '#e1f4f9' },
    100: { value: '#d1e0ef' },
    500: { value: '#42B2E5' },
  },
  'brand-purple': {
    50: { value: '#efeaf9' },
    100: { value: '#e8ddf2' },
    500: { value: '#B15BBF' },
  },
};

const onSecondaryPalette = {
  'on-navy': {
    50: { value: '#e7ebee' },
    100: { value: '#b3bfca' },
    200: { value: '#8ea1b0' },
    300: { value: '#5b768c' },
    400: { value: '#3b5b76' },
    500: { value: '#0A3254' }, //on-navy
    600: { value: '#092e4c' },
    700: { value: '#07243C' },
    800: { value: '#061c2e' },
    900: { value: '#041523' },
  },
  'on-lime': {
    50: { value: '#f1f8e9' },
    100: { value: '#d5eaba' },
    200: { value: '#c0e099' },
    300: { value: '#a3d26a' },
    400: { value: '#91c94d' },
    500: { value: '#76bc21' }, //on-lime
    600: { value: '#6bab1e' },
    700: { value: '#548517' },
    800: { value: '#416712' },
    900: { value: '#324f0e' },
  },
  'on-evergreen': {
    50: { value: '#e6edee' },
    100: { value: '#b0c8c9' },
    200: { value: '#8aaeaf' },
    300: { value: '#54898a' },
    400: { value: '#337274' },
    500: { value: '#004f51' }, //on-evergreen
    600: { value: '#00484a' },
    700: { value: '#00383a' },
    800: { value: '#002b2d' },
    900: { value: '#002122' },
  },
};

const rating = {
  1: { value: '#E84849' }, //red
  2: { value: '#F37F65' },
  3: { value: '#F6CC5E' },
  4: { value: '#79DDA7' },
  5: { value: '#3FC07B' }, //green
};

const link = {
  1: { value: '#116CD4' },
  2: { value: '#C2D0E8' },
};

const chart = {
  merlot: { value: '#87051B' },
  chili: { value: '#C2060E' },
  raspberry: { value: '#E40A58' },
  bubblegum: { value: '#FF5AA3' },
  lavender: { value: '#B67FCD' },
  violet: { value: '#BF1794' },
  plum: { value: '#5C2788' },
  storm: { value: '#0F3C5C' },
  denim: { value: '#074A86' },
  azure: { value: '#128BCF' },
  sky: { value: '#5DD0FB' },
  glacier: { value: '#00D5D3' },
  teal: { value: '#00877C' },
  forest: { value: '#175D40' },
  fern: { value: '#40912F' },
  guac: { value: '#9BC127' },
  lime: { value: '#96F43D' },
  honey: { value: '#F0B703' },
  apricot: { value: '#FD9329' },
  tomato: { value: '#EB5034' },
  mustard: { value: '#CC9522' },
  cinnamon: { value: '#A76400' },
  bark: { value: '#6D5924' },
};

// Currently required to make components not look silly
// We'll need to retheme every component if we want to remove these (because they default to e.g. "gray.300")
// We can also override these ourselves if we come up with our own palette (e.g. scales based on our palette)
const chakraPalette = {
  gray: {
    // Page and Tooltip background color
    25: { value: '#FAFAFA' },
    50: { value: '#F7FAFC' },
    // Skeleton, borders, hover
    100: { value: '#EDF2F7' },
    200: { value: '#E2E8F0' },
    300: { value: '#CBD5E0' },
    400: { value: '#A0AEC0' },
    500: { value: '#718096' },
    // Table header text
    600: { value: '#4A5568' },
    700: { value: '#2D3748' },
    // Default text
    800: { value: '#1A202C' },
    900: { value: '#171923' },
  },
  //on-blue
  blue: {
    50: { value: '#e6f1f8' },
    100: { value: '#b0d5ea' },
    200: { value: '#8ac0e0' },
    300: { value: '#54a3d1' },
    400: { value: '#3391c9' },
    500: { value: '#0076bb' }, // base colour
    600: { value: '#006baa' },
    700: { value: '#005485' },
    800: { value: '#004167' },
    900: { value: '#00324f' },
  },
  red: {
    50: { value: '#fdeceb' },
    100: { value: '#fac3c2' },
    200: { value: '#f8a5a4' },
    300: { value: '#f47c7a' },
    400: { value: '#f26361' },
    500: { value: '#ef3c39' }, //on-red
    600: { value: '#d93734' },
    700: { value: '#aa2b28' },
    800: { value: '#83211f' },
    900: { value: '#641918' },
  },
  white: { value: '#ffffff' },
  whiteAlpha: {
    50: { value: 'rgba(255, 255, 255, 0.04)' },
    100: { value: 'rgba(255, 255, 255, 0.06)' },
    200: { value: 'rgba(255, 255, 255, 0.08)' },
    300: { value: 'rgba(255, 255, 255, 0.16)' },
    400: { value: 'rgba(255, 255, 255, 0.24)' },
    500: { value: 'rgba(255, 255, 255, 0.36)' },
    600: { value: 'rgba(255, 255, 255, 0.48)' },
    700: { value: 'rgba(255, 255, 255, 0.64)' },
    800: { value: 'rgba(255, 255, 255, 0.80)' },
    // Tooltip text
    900: { value: 'rgba(255, 255, 255, 0.92)' },
  },
  blackAlpha: {
    50: { value: 'rgba(0, 0, 0, 0.04)' },
    100: { value: 'rgba(0, 0, 0, 0.06)' },
    200: { value: 'rgba(0, 0, 0, 0.08)' },
    300: { value: 'rgba(0, 0, 0, 0.16)' },
    // Nav button hover
    400: { value: 'rgba(0, 0, 0, 0.24)' },
    // Nav bar active
    500: { value: 'rgba(0, 0, 0, 0.36)' },
    // Modal overlay
    600: { value: 'rgba(0, 0, 0, 0.48)' },
    700: { value: 'rgba(0, 0, 0, 0.64)' },
    800: { value: 'rgba(0, 0, 0, 0.80)' },
    900: { value: 'rgba(0, 0, 0, 0.92)' },
  },
  // Used in alerts, toasts
  // on-emerald
  green: {
    50: { value: '#e7f3ed' },
    100: { value: '#b4d9c8' },
    200: { value: '#90c7ad' },
    300: { value: '#5dad88' },
    400: { value: '#3d9d71' },
    500: { value: '#0d854d' }, //on-emerald
    600: { value: '#0c7946' },
    700: { value: '#095e37' },
    800: { value: '#07492a' },
    900: { value: '#053820' },
  },
  //on-yellow
  yellow: {
    50: { value: '#fffaec' },
    100: { value: '#fff1c4' },
    200: { value: '#ffeaa7' },
    300: { value: '#ffe07f' },
    400: { value: '#ffda66' },
    500: { value: '#ffd140' }, //on-yellow
    600: { value: '#e8be3a' },
    700: { value: '#b5942d' },
    800: { value: '#8c7323' },
    900: { value: '#6b581b' },
  },
  //on-orange
  orange: {
    50: { value: '#fef2eb' },
    100: { value: '#fcd7c2' },
    200: { value: '#fac4a4' },
    // Used in Mark for highlighting
    300: { value: '#f8a97b' },
    400: { value: '#f69861' },
    500: { value: '#f47e3a' }, //on-orange
    600: { value: '#de7335' },
    700: { value: '#ad5929' },
    800: { value: '#864520' },
    900: { value: '#663518' },
  },
};

export const colours = {
  ...chakraPalette,
  ...onPrimaryPalette,
  ...onSecondaryPalette,
  rating,
  link,
  chart,
  'on-logo-grey': { value: '#333333' },
};
